export default "__VITE_ASSET__CkaLhzKw__"